/** Only for pre-Pointer-Events Safari: a touch belongs to this small drag surface. */
export function bindLegacyScoreTouch(input: HTMLInputElement, onChange: (value: number) => void) {
  let activeId: number | null = null;
  const prevent = (event: TouchEvent) => { if (event.cancelable) event.preventDefault(); };
  const update = (touch: Touch) => {
    const rect = input.getBoundingClientRect();
    const min = Number(input.min);
    const max = Number(input.max);
    const step = Number(input.step) || 1;
    // The thumb's centre travels between its two 14px edge insets.
    const fraction = Math.max(0, Math.min(1, (touch.clientX - rect.left - 14) / Math.max(1, rect.width - 28)));
    const lastStep = Math.floor((max - min) / step + 1e-9);
    const index = Math.min(lastStep, Math.round(fraction * (max - min) / step));
    const value = Number((min + index * step).toFixed(10));
    input.value = String(value);
    onChange(value);
  };
  const start = (event: TouchEvent) => {
    if (activeId !== null) { prevent(event); return; }
    if (!event.changedTouches.length) return;
    prevent(event);
    const touch = event.changedTouches[0];
    activeId = touch.identifier;
    update(touch);
  };
  const move = (event: TouchEvent) => {
    if (activeId === null) return;
    prevent(event);
    for (let i = 0; i < event.changedTouches.length; i++) {
      if (event.changedTouches[i].identifier === activeId) update(event.changedTouches[i]);
    }
  };
  const end = (event: TouchEvent) => {
    for (let i = 0; i < event.changedTouches.length; i++) {
      if (event.changedTouches[i].identifier === activeId) { prevent(event); activeId = null; }
    }
  };
  const listeners: [string, EventListener][] = [['touchstart', start as EventListener], ['touchmove', move as EventListener], ['touchend', end as EventListener], ['touchcancel', end as EventListener]];
  for (const [name, listener] of listeners) input.addEventListener(name, listener, { passive: false });
  return () => { for (const [name, listener] of listeners) input.removeEventListener(name, listener); activeId = null; };
}
